module.exports = __webpack_public_path__ + "media/bootstrap-icons/fullscreen-f04ef8ae.svg";